<template>
  <div class="QRComponent">
    <p
      class="subtitle"
      :class="{ error: innerError }"
      :v-if="label"
    >
      {{ label }}
    </p>
    <div
      v-if="!innerError"
      class="qr-code"
      :class="{ 'is-file-attached': isFileAttached }"
    >
      <div>
        <qrcode-vue
          :value="innerValue"
          :level="level"
          :render-as="renderAs"
          :background="background"
          :foreground="foreground"
          :gradient="gradient"
        />
      </div>
    </div>
    <div
      class="qr-code"
      v-else
    >
      <div class="container">
        <i class="icon-informacion overlay" />
        <qrcode-vue
          class="qr-error"
          value=""
          :level="level"
          :render-as="renderAs"
          :background="background"
          :foreground="foreground"
          :gradient="gradient"
        />
      </div>
      <p class="error restart-message"><b>¿No aparece el qr? Pulsa reintentar</b></p>
      <BaseButton
        type="transparent"
        @click="emit('retry')"
      >
        Reintentar
      </BaseButton>
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue'
  import QrcodeVue from 'qrcode.vue'
  import type { Level, RenderAs } from 'qrcode.vue'

  import BaseButton from './BaseButton.vue'
  import { watch } from 'vue'

  const DEFAULT_BACKGROUND = '#ffffff'
  const DEFAULT_FOREGROUND = '#000000'

  // const ERROR_BACKGROUND = '#E9E9EB'
  // const ERROR_FOREGROUND = '#ffffff'

  //TODO: Move text messages to locale
  const level = ref<Level>('M')
  const renderAs = ref<RenderAs>('svg')
  const background = ref(DEFAULT_BACKGROUND)
  const foreground = ref(DEFAULT_FOREGROUND)

  const gradient = ref(false)
  const emit = defineEmits(['retry'])

  interface PropsInterface {
    value: string
    label?: string
    isFileAttached?: boolean
    error?: boolean
  }

  const props = withDefaults(defineProps<PropsInterface>(), {})
  const innerError = computed(() => props.error)
  const innerValue = ref(props.value)
  const isFileAttached = computed(() => props.isFileAttached)

  watch(isFileAttached, (newValue) => {
    if (newValue) {
      return (innerValue.value = '')
    }
    return (innerValue.value = props.value)
  })
</script>
<style lang="scss" scoped>
  .QRComponent {
    .subtitle {
      margin: $padding-5 0;
      color: $color-neutral;
      font-size: $font-size-m;
      font-weight: $font-weight-400;
      line-height: $line-height-140p;
    }

    p {
      color: $color-neutral;
    }

    .qr-code {
      display: flex;
      justify-content: center;
      flex-direction: column;

      div {
        border: solid 1px $color-grey-400;
        border-radius: $b-radius-4;
        padding: $spacing-s;
        margin: $spacing-l 0 $spacing-2xl;
        align-self: center;
      }

      .container {
        position: relative;
        display: inline-block;
      }

      .overlay {
        width: $size-full;
        height: $size-full;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        font-size: $font-size-3xl;
        font-weight: $font-weight-900;
        text-align: center;
        color: $color-error;
        padding-top: 30%;
        z-index: $z-index-01;
      }

      .qr-error {
        opacity: 0.1;
      }

      &.is-file-attached {
        opacity: 0.3;
      }
    }

    .error {
      color: $color-neutral;

      &.restart-message {
        text-align: center;
      }
    }
  }
</style>
